import { type MetaFunction } from '@remix-run/node'
import allstate from './allstate.png'

export const meta: MetaFunction = () => [
	{ title: 'Allstate' },
	{
		name: 'description',
		content: 'We offer Allstate Insurance',
	},
]

export default function Component() {
	return (
		<main className="mx-auto my-10 max-w-7xl">
			<h1 className="py-3 text-4xl font-black">Allstate</h1>

			<img src={allstate} alt="Allstate" className="w-64" />

			<section>
				<h3>History</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					Allstate has roots dating back to 1931, the year it was founded. As
					the story goes, Carl Odell proposed to his neighbor (President of
					Sears) Robert Wood an idea to sell insurance through the mail and
					reduce costs. Sears also offered insurance products through its
					catalogs. By 1933 there were over 22,000 active policies. They are now
					a publicly traded company operating under the ticker symbol "ALL."
				</p>
				<h3>Products</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					It should be clear from the strong television and internet marketing
					campaigns that Allstate is a big player in the auto insurance
					industry, but what many people do not know is that they're also very
					competitive with powersports, including snowmobile, boat, and
					motorcycle. In addition to insuring the things that move you, they
					have programs for homeowners, renters, condos, and landlords. On the
					business side, Allstate has some niche programs that are very
					competitive for small and medium-sized businesses.
				</p>
				<h3>Financial Strength</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					As one of the most nationally recognized brand images in the industry,
					Allstate has a strong market position. They are also a financially
					stable company, earning a rating from A.M. Best of A+ (Superior).
				</p>
				<h3>Contact Information</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					Website:{' '}
					<a
						href="https://www.allstate.com"
						target="_blank"
						rel="noopener noreferrer"
					>
						https://www.allstate.com/ (opens in a new tab)
					</a>
				</p>

				<h3>Claims</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					(800) 347-4711
				</p>
				<h3>Make a Payment</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					<a
						title="Allstate Customer Care Center"
						href="https://www.allstate.com/support/payment-and-billing.aspx"
						target="_blank"
						rel="noopener noreferrer"
					>
						https://www.allstate.com/support/payment-and-billing.aspx (opens in
						a new tab)
					</a>
				</p>
			</section>
			<section>
				<h3>Home Office Address</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					Allstate Insurance Company
					<br />
					2775 Sanders Road
					<br />
					Northbrook, IL 60062
				</p>
			</section>
		</main>
	)
}
